module.exports = __webpack_public_path__ + "media/my_images/owner/plan-c0cb3fa8c6c561cf827350e7624773be.jpg";